import React, { useEffect, useState } from "react";

import Window from "../../../../elements/window";

import Slide1 from "./slides/slide1";
import Slide2 from "./slides/slide2";
import Slide3 from "./slides/slide3";
import Slide4 from "./slides/slide4";

import Loader from "../../../../../settings/loader";
import { useAppContext } from "../../../../../../AppContext";

function SalesSummary({ filter }) {
  const { user, chimeraserv } = useAppContext();
  const props = { user, chimeraserv, filter };
  const [sales, setSales] = useState(null);
  const [brandwiseSales, setBrandwiseSales] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        if (props?.user?.data) {
          await fetchData();
        }
      } catch (err) {
        console.log("Error occured when fetching");
      }
    })();
  }, []);

  const fetchData = async () => {
    const getSales = await fetch(props.chimeraserv.urlGet + "/by-sales-v2", {
      method: "POST",
      headers: {
        Authorization: props.user.data.usrKey,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        base64filter: props.filter.base64,
      }),
    });

    const jsonRes = await getSales.json();

    const chains = props?.filter?.data?.chains;
    const brands = props?.filter?.data?.brands;

    const withNames = jsonRes?.map((item) => {
      return {
        ...item,
        currency: `${
          chains
            ?.find((chainItem) => chainItem?.chaKey == item?.chaKey)
            ?.currency?.toUpperCase() || "QAR"
        }`,
        restaurant_name: `${
          chains?.find((chainItem) => chainItem?.chaKey == item?.chaKey)?.name
        }`,
        brand_name: `${
          brands?.find((brandItem) => brandItem?.braKey == item?.braKey)?.name
        }`,
      };
    });

    await setSales(withNames);

    // Prepare brandwise data
    const brandwise = brands?.map((brand) => {
      // Find all chains for this brand
      const brandChains = chains?.filter(
        (chain) => chain.braKey === brand.braKey
      );
      // Find all sales for these chains
      const brandSales = withNames.filter((sale) =>
        brandChains.some((chain) => chain.chaKey === sale.chaKey)
      );
      // Sum total sales and checks
      const totalOpenSales = brandSales.reduce(
        (sum, sale) => sum + (sale.totalOpenSales || 0),
        0
      );
      const totalClosedSales = brandSales.reduce(
        (sum, sale) => sum + (sale.totalClosedSales || 0),
        0
      );
      const checkCount = brandSales.reduce(
        (sum, sale) => sum + (sale.checkCount || 0),
        0
      );
      return {
        brand_name: brand.name,
        currency:
          brandChains[0]?.currency?.toUpperCase() ||
          props?.filter?.data?.groups?.[0]?.baseCurr?.toUpperCase() ||
          "QAR",
        totalOpenSales,
        totalClosedSales,
        checkCount,
      };
    });

    setBrandwiseSales(brandwise);
    setSales(withNames);
  };

  return sales ? (
    <div className={["contentContainer"]}>
      <div className={["contentRow"]} style={{ width: "100%" }}>
        <Window
          user={props.user}
          chimeraserv={props.chimeraserv}
          title={"Sales by Summary"}
          horizontal
        >
          <Slide1
            {...props}
            slideData={JSON.parse(JSON.stringify(sales))}
            //striginfy to store as value not as reference so no original array changes when modify the copy
          />
        </Window>
      </div>

      <div className={["contentRow"]} style={{ width: "100%" }}>
        <Window
          user={props.user}
          chimeraserv={props.chimeraserv}
          title={"Open and Closed Sales"}
          horizontal
        >
          <Slide2 {...props} slideData={JSON.parse(JSON.stringify(sales))} />
        </Window>
      </div>
      {/* Groupwise Sales Summary */}
      <div className={["contentRow"]} style={{ width: "100%" }}>
        <Window
          user={props.user}
          chimeraserv={props.chimeraserv}
          title={"Sales Summary by Brand"}
          horizontal
        >
          <Slide3
            {...props}
            slideData={JSON.parse(JSON.stringify(brandwiseSales))}
            brandwise
          />
        </Window>
      </div>
      {/* Groupwise Open and Closed Sales */}
      <div className={["contentRow"]} style={{ width: "100%" }}>
        <Window
          user={props.user}
          chimeraserv={props.chimeraserv}
          title={"Open and Closed Sales by Brand"}
          horizontal
        >
          <Slide4
            {...props}
            slideData={JSON.parse(JSON.stringify(brandwiseSales))}
            brandwise
          />
        </Window>
      </div>
    </div>
  ) : (
    <Loader />
  );
}

export default SalesSummary;
